var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:[
    _vm.alignCustomize,
    '   bg-ontick-graphite px-3 py-4 text-xs font-bold uppercase leading-4 text-white ',
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }